import { LocalDate } from '@js-joda/core';

import { ButtonVariant, ContextDialog } from '@dreryk/react-components';

import {
   CurrentHealthcareProviderInvoicePdfLoader,
   downloadInvoiceAsPdf,
   InvoiceCreateModalOpener,
} from '~legacy.invoice';

import { visitSettlementTranslationKeys } from '../../../translations';

type VisitSettlementCalendarTabContextDialogInvoiceCreateButtonProps = {
   readonly disabled: boolean;
   readonly patientId: number;
   readonly visitDate: LocalDate;
   readonly appointmentId: number;
   readonly visitSettlementId: number;
};

export const VisitSettlementCalendarTabContextDialogInvoiceCreateButton = (
   props: VisitSettlementCalendarTabContextDialogInvoiceCreateButtonProps
): JSX.Element => {
   return (
      <CurrentHealthcareProviderInvoicePdfLoader referenceId={props.visitSettlementId.toString()}>
         {({ invoiceExists }) => (
            <>
               {invoiceExists ? (
                  <ContextDialog.ConfirmButton
                     testId={'downloadInvoice'}
                     label={visitSettlementTranslationKeys.extensions.calendar.tab.downloadInvoiceButton}
                     onClick={downloadInvoiceAsPdf(props.visitSettlementId.toString())}
                     variant={ButtonVariant.SECONDARY}
                     disabled={props.disabled}
                  />
               ) : (
                  <InvoiceCreateModalOpener
                     patientId={props.patientId}
                     appointmentId={props.appointmentId}
                     visitDate={props.visitDate}
                     visitSettlementId={props.visitSettlementId}
                  >
                     {({ openModal }) => (
                        <ContextDialog.ConfirmButton
                           testId={'openInvoiceCreateModal'}
                           label={visitSettlementTranslationKeys.extensions.calendar.tab.createInvoiceButton}
                           onClick={openModal}
                           variant={ButtonVariant.SECONDARY}
                           disabled={props.disabled}
                        />
                     )}
                  </InvoiceCreateModalOpener>
               )}
            </>
         )}
      </CurrentHealthcareProviderInvoicePdfLoader>
   );
};
